import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getClientsTypicalProblems(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Aplikace na míru",
			desc: "Potřebujeme pomoci s nastavením firemních procesů a digitalizovat je do podoby aplikace.",
		},
		{
			title: "Nevyhovující krabicové řešení",
			desc: "Máme nastavené procesy, ale stávající krabicové řešení už nám nevyhovuje.",
		},
		{
			title: "E-shop nebo web na přání",
			desc: "Chceme nový e-shop. Uměli byste ho propojit s našimi systémy a přidat do něj specifické funkcionality?",
		},
		{
			title: "Od základů vlastní IT produkt",
			desc: "Mám nápad na vlastní IT řešení a rád bych ho s vámi realizoval/a od úplných základů.",
		},
	];
}
